import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MinorService } from 'src/app/services/minor/minor.service';

export interface Opt {
  value: string;
  viewValue: string;
}
@Component({
  selector: 'app-form-fields',
  templateUrl: './form-fields.component.html',
  styleUrls: ['./form-fields.component.scss']
})


export class FormFieldsComponent {
  @Input() form: FormGroup = new FormGroup({});
  @Input() control="";
  @Input() type="";
  @Input() value="";
  @Input() label="";
  @Input() min=0;
  @Input() max=0;
  @Input() id="";
  @Input() linkPrivacyTos ="";
  @Input() options:Opt[] |undefined;
  @Input() description= "";
  @Input() initiativeId = "";
  @Input() required = false;
  @Input() isMinorPlus =  false;
  isTeamSelected: string ="";
  isVisibleListTeam:boolean = true;
  constructor( private minorService: MinorService){
  }
  ngOnInit(){
    if(this.initiativeId){
      this.minorService.favoriteTeam$.subscribe((list:any)=>{
        if(this.initiativeId == list?.id){
          Object.keys(list.list).forEach((team:any) => {
            let obj: Opt ={
              value: JSON.stringify({CodSquadra:list.list[team]?.CodSquadra, key:"favourite_"+this.initiativeId}),
              viewValue: list.list[team].NmeBreve
            };
            this.options?.push(obj);
          });
        }
      });
    }

  }
}
